import React from "react";
import { useSelector } from "react-redux";

import AccountDetailsCard from "./card/accountDetailsCard";
// import Button, { ButtonSizes, ButtonThemes } from "../../../ui-components/button/button";
import { ReactComponent as PersonIcon } from "../../images/person.svg";
import teamsLogo from "../../images/teams-logo.png";
// import { ReactComponent as EditIcon } from "../../images/edit_icon.svg";
// import { ReactComponent as BinIcon } from "../../images/bin.svg";

import { accountDetailsSelector } from "../../slices/account-details/accountDetailsSlice";

const AccountDetailsSalesman: React.FC<{}> = () => {
  const { companyInfo } = useSelector(accountDetailsSelector);
  const salesman = companyInfo && companyInfo.salesPerson;

  const rows = [
    {
      label: "Region",
      value: salesman?.address && `${salesman?.address.city}, ${salesman?.address.state}`,
    },
    {
      label: "Cell Phone",
      value: salesman?.phone && salesman.phone !== "0" ? salesman.phone.formatPhone() : undefined,
    },
    {
      label: "Email",
      value: salesman?.email,
    },    
  ];  

  return (
    <AccountDetailsCard
      title="Sales Representative"
      icon={<PersonIcon />}
      mix="account-details__salesman-card"
    >
      <div className="account-details__card__content-block">
        {salesman ? <>
          <div className="account-details__card__row account-details__salesman-card__header">
            <div className="account-details__card__item">
              <div className="account-details__card__icon">
                {salesman?.firstName.slice(0, 1)}
              </div>
              <div>
                <div>{`${salesman?.firstName} ${salesman?.lastName}`}<div />
                </div>
              </div>
            </div>
            {salesman.email && <a className="account-details__salesman-card__teams-link" href={`https://teams.microsoft.com/l/chat/0/0?users=${salesman.email}`} target="_blank" rel="noreferrer">
              <img src={teamsLogo} alt="Teams logo" />
            </a>}
          </div>

          <div className="account-details__salesman-card__content">
            {rows.map((row, index) => (
              <div key={index} className="account-details__card__row account-details__card__content-row">
                <span className="account-details__card__label">{row.label}:</span>
                <span>{row.value || "-"}</span>
              </div>
            ))}
          </div>

          {/* <div className="account-details__card__row">
        <Button className="account-details__salesman-card__button" theme={ButtonThemes.blueInverted} size={ButtonSizes.small}>
          <div className="xgs-btn__icon-container"><EditIcon /></div>Edit
        </Button>
        <Button className="account-details__salesman-card__button" theme={ButtonThemes.blueInverted} size={ButtonSizes.small}>
          <div className="xgs-btn__icon-container"><BinIcon /></div>Remove
        </Button>
      </div> */}
        </> : <div>No information available</div>}
      </div>
    </AccountDetailsCard>
  );
};

export default AccountDetailsSalesman;